import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { sentinelModule } from "../modules/sentinelModule";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { accountApi_template } from "../components/templates/accountApi_template";

declare var ko: any;

export class accountApi extends sentinelModule{

    protected XHRHdl: XMLHttpRequestHandler;
    protected accountApi_template: accountApi_template;

    protected getModuleName(){

        return "accountApi";
    }

    buildContent() : Array<Element>{

        const parentContent = super.buildContent();

        // create the accountApi list
        this.accountApi_template = new accountApi_template("accountApi", this.viewModel, this);
        this.template = this.accountApi_template;

        return [...parentContent, this.accountApi_template.build()];
    }

    fillPage() : void{

        this.getPermissions();
        this.getSearchPresetsListData();
    }

    protected getPermissions(){

        this.loadingIn(this.accountApi_template.builtTemplate.querySelector("#accountApi-results"));

        let accPermissions_url: string = '/api/settings/menuData';
        let accPermissions_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(accPermissions_url, accPermissions_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPermissionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetPermissionsReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.loadingOut(obj.accountApi_template.builtTemplate.querySelector("#accountApi-results"));
                obj.accountApi_template.setSideMenuPermissionsData(responseParsed);
            })
        }
    }

    protected getListFormData(): void{

        this.loadingIn(this.accountApi_template.builtTemplate.querySelector("#accountApi-results"));

        let subViewModel = this.accountApi_template.getViewModelForRequest();

        let usrReq_url: string = '/api/settings/api/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj): Function {

        return function() {

            obj.manageResponse(req, obj, function () {

                obj.updateViewModelFromPath();
                obj.getListData();
            });

            obj.loadingOut(obj.accountApi_template.builtTemplate.querySelector("#accountApi-results"));
        }
    }

    public getListData(): void{

        this.loadingIn(this.accountApi_template.builtTemplate.querySelector("#accountApi-results"));

        let subViewModel = this.accountApi_template.getViewModelForRequest();
        let baseApiUrl = '/api/settings/api/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onDataRequestReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.updateApiKey(responseParsed.apiKey);
                obj.updateApiKeyEnabled(responseParsed.apiKeyEnabled);
                obj.updateApiCode(responseParsed.apiCode);
                obj.updateIsLoaded();
            });

            obj.loadingOut(obj.accountApi_template.builtTemplate.querySelector("#accountApi-results"));
        };
    }

    private getXHRHdl(baseURl, callIdentifier){

        let callKey =   baseURl + '-' + callIdentifier;

        return this.XHRHdls[callKey];
    }

    protected updateApiKey(apiKey){

        this.accountApi_template.setApiKey(apiKey);
    }

    protected updateApiKeyEnabled(apiKeyEnabled){

        this.accountApi_template.setApiKeyEnabled(apiKeyEnabled);
    }

    protected updateApiCode(apiCode){

        this.accountApi_template.setApiCode(apiCode);
    }

    protected updateIsLoaded(){

        this.accountApi_template.setIsLoaded();
    }

    protected onGenerateApiKey() {

        this.loadingIn(this.accountApi_template.builtTemplate.querySelector("#accountApi-results"));

        let subViewModel = this.accountApi_template.getViewModelForRequest();

        let accountApiReq_url: string = '/api/settings/api/generate';
        let accountApiReq_params: Array<Array<string>> = [];
        accountApiReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(accountApiReq_url, accountApiReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onGenerateApiKeyReturn;
        this.XHRHdl.execute();
    }

    protected onGenerateApiKeyReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateApiKey(responseParsed.apiKey);
                obj.updateApiCode(responseParsed.apiCode);
            });


            obj.loadingOut(obj.accountApi_template.builtTemplate.querySelector("#accountApi-results"));
        };
    }

    protected onEnableApiKey() {

        this.loadingIn(this.accountApi_template.builtTemplate.querySelector("#accountApi-results"));

        let subViewModel = this.accountApi_template.getViewModelForRequest();

        let accountApiReq_url: string = '/api/settings/api/enable';
        let accountApiReq_params: Array<Array<string>> = [];
        accountApiReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(accountApiReq_url, accountApiReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onEnableApiKeyReturn;
        this.XHRHdl.execute();
    }

    protected onEnableApiKeyReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateApiKeyEnabled(responseParsed.apiKeyEnabled);
                obj.updateApiCode(responseParsed.apiCode);
            });

            obj.loadingOut(obj.accountApi_template.builtTemplate.querySelector("#accountApi-results"));
        };
    }

    public copyToClipboardNotification(){

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Copied to clipboard");
        this.getVnAppZone().showNotificationToModule();
    }
}



// WEBPACK FOOTER //
// ./js/modules/accountApi.ts